import { HotelList } from 'proto/Hotel/Hotel';

export const getItemCount = (
    accommodationList: HotelList,
    alternativeHotelList: HotelList,
    currentPage: number
) => {
    if (accommodationList.itemOrder.length === 0 && currentPage > 1) {
        return alternativeHotelList.count + accommodationList.count;
    }

    return accommodationList.count;
};
